/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Completed from './Completed/index'
import Error from './Error/index'
import Matching from './Matching/index'
import No from './No/index'
import React from 'react'
import SyncPatients from './SyncPatients/index'
import Syncing from './Syncing/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/Sync/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let syncStatusValueData = fromData.useDataValue({ viewPath,
context: 'sync',
path: 'status',
})
let tabSelectedSyncIsMatchingValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.sync_is_matching',
})
let aggregateData = fromHelpers.getView(syncStatusValueData, tabSelectedSyncIsMatchingValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: aggregateData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Error'}>
<Error
  viewPath={`${viewPath}/Error`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Syncing'}>
<Syncing
  viewPath={`${viewPath}/Syncing`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Matching'}>
<Matching
  viewPath={`${viewPath}/Matching`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'SyncPatients'}>
<SyncPatients
  viewPath={`${viewPath}/SyncPatients`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Completed'}>
<Completed
  viewPath={`${viewPath}/Completed`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}